import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const items = [
    {
      q: "A IA fala mesmo Português de Portugal?",
      a: "Sim. A Automia está afinada para o pt-PT, com vocabulário, expressões e tom de cá. Nada de brasileirismos nem traduções estranhas. O nome da IA é seu (\"Sofia\", \"Assistente Clínica X\", o que preferir).",
    },
    {
      q: "E se a IA não souber responder?",
      a: "Não inventa. Quando a confiança da resposta é baixa, a IA pausa-se automaticamente e envia-lhe uma notificação no seu WhatsApp pessoal. Retoma sozinha ao fim do tempo combinado consigo (ex: 4h).",
    },
    {
      q: "A IA pode ser desligada a qualquer momento?",
      a: "Sim, pode desligá-la globalmente ou apenas em conversas específicas. Mantém também uma lista de números bloqueados para a IA ignorar.",
    },
    {
      q: "Tenho muito que configurar?",
      a: "Não. Só nos diz como é o seu negócio e o que prefere; tratamos de toda a configuração técnica. Ligação ao WhatsApp, Google Calendar, base de conhecimento, lembretes, tudo. Entregamos o sistema pronto a usar.",
    },
    {
      q: "Posso aprovar marcações antes de confirmar?",
      a: "Pode. Existem dois modos: automático (a IA confirma sozinha quando há slot livre) ou manual (a IA propõe e aprova com um toque). Diz-nos a sua preferência e nós configuramos.",
    },
    {
      q: "Como ensinam a Automia sobre o meu negócio?",
      a: "Envia-nos o link do seu site ou um texto sobre o seu negócio. A Automia extrai sozinha morada, horários, serviços e preços. Reveja com calma e nós deixamos tudo afinado para responder no tom da sua casa.",
    },
    {
      q: "Os meus clientes recebem lembretes?",
      a: "Sim. Lembretes automáticos via WhatsApp antes da marcação. Diga-nos quantas horas antes e deixamos isso a funcionar.",
    },
    {
      q: "Quanto custa?",
      a: "Os planos da Automia são feitos à medida do seu negócio. Peça uma demo e mostramos-lhe o que faz mais sentido para si.",
    },
  ];

  return (
    <section id="faq" data-testid="faq-section" className="relative py-16 sm:py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass-card text-[11px] font-semibold uppercase tracking-[0.2em] text-blue-300">
            FAQ
          </div>
          <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl tracking-tighter text-white leading-[1.05]">
            Perguntas frequentes
          </h2>
          <p className="mt-4 text-slate-400 max-w-xl">
            Tudo o que tem perguntado antes de pedir uma demo.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-2">
          {items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-accordion-item-${i}`}
              className="border-b border-white/[0.06] border-t-0 border-x-0 px-1"
            >
              <AccordionTrigger className="py-5 text-left text-base md:text-lg text-white hover:text-blue-300 hover:no-underline tracking-tight font-medium">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-slate-400 leading-relaxed text-base">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
